import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ParalysisPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Paralysis</h1>
        <section className="mb-8">
          <p>Paralysis is the loss of muscle function in part of the body, often caused by damage to the nervous system. Our natural therapies focus on nerve regeneration, muscle strengthening, and improving mobility through herbal remedies and specialized treatments.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Stroke</li>
            <li>Spinal cord injury</li>
            <li>Traumatic brain injury</li>
            <li>Multiple sclerosis</li>
            <li>Nerve damage</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Loss of muscle control</li>
            <li>Numbness or tingling</li>
            <li>Muscle weakness</li>
            <li>Difficulty speaking</li>
            <li>Balance problems</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use nerve-regenerating herbs, muscle-strengthening remedies, and specialized therapies to naturally treat paralysis. Our approach focuses on improving nerve function and muscle control through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Improved nerve function</li>
            <li>Enhanced muscle control</li>
            <li>No harsh side effects</li>
            <li>Better quality of life</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Regular physiotherapy</li>
            <li>Balanced nutrition</li>
            <li>Stress management</li>
            <li>Proper rest and sleep</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Recovery time varies, but many patients notice improvement within 3-6 months of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment suitable for all types of paralysis?</strong>
            <p>A: Yes, our natural remedies can be adapted for different types and severities of paralysis.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment be combined with conventional therapy?</strong>
            <p>A: Yes, our holistic approach can complement conventional treatments for better results.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from paralysis—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default ParalysisPage; 